export type Appearance = 'system' | 'dark' | 'light';

const COOKIE_NAME = 'resonance_appearance';

export function readPublicAppearance(): Appearance {
  if (typeof document === 'undefined') return 'system';
  const value = document.cookie
    .split('; ')
    .find((part) => part.startsWith(`${COOKIE_NAME}=`))
    ?.slice(COOKIE_NAME.length + 1);
  return value === 'dark' || value === 'light' ? value : 'system';
}

export function writePublicAppearance(appearance: Appearance): void {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${appearance}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
}
